export default "__VITE_ASSET__Bq3Az4VG__"